"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAmountLength = exports.sanitizeInput = exports.formatCurrency = exports.roundUp = void 0;
/**
 * Rounds to nearest significant figure
 *
 * @param num Number to round
 * @param near Nearest number to round to
 * @returns number
 */
const roundUp = (num, near) => {
    return Math.ceil(num / near) * near;
};
exports.roundUp = roundUp;
/**
 * Formats into local currency
 *
 * @param number Number to format
 * @param currency local currency to format into
 * @returns string
 */
const formatCurrency = (number, currency, locale) => {
    return Intl.NumberFormat(locale || "en", {
        currency,
        style: "currency",
    }).format(number);
};
exports.formatCurrency = formatCurrency;
/**
 * Sanitises input target value strings to number
 *
 * @param str string to be sanitsed
 * @returns number
 */
const sanitizeInput = (str) => {
    const regex = /[^0-9.]+/g;
    const sanitized = str.replace(regex, "");
    console.log("sanitized", sanitized);
    return parseFloat(sanitized);
};
exports.sanitizeInput = sanitizeInput;
/**
 * Formats the length of integer/decimal to be displayed
 *
 * @param amount crypto/fiat amount
 * @param locale
 * @returns number
 */
const formatAmountLength = (amount, locale) => {
    const integerLength = amount.toString().split(".")[0].length;
    if (integerLength > 5) {
        const formatter = Intl.NumberFormat(locale, {
            notation: "compact",
            minimumFractionDigits: 1,
            maximumFractionDigits: 2,
        });
        return formatter.format(Number(amount));
    }
    return amount.toFixed(5);
};
exports.formatAmountLength = formatAmountLength;
//# sourceMappingURL=math.js.map